import { space } from '../spacing.js';
export const container = {
    top: '25%',
    paddingLeft: space.x6,
    paddingRight: space.x6,
};
//# sourceMappingURL=empty-state.js.map